export function formatCamelCase (s) {
  if (s === undefined || s === 'N/A') {
    return '-'
  }
  let arr = s.replaceAll('/', ' ').split(' ')
  arr = arr.map((d) => d[0].toUpperCase() + d.substring(1))
  return arr.join(' ')
}
